export function _getInitialRPCState(state) {
    return {
        ...state,
        moreMenuVisible: false,
        presentMenuVisible: false
    };
}

export function RPC_ToolBoxReducer(state, action) {
    switch (action.type) {
    case 'SET_MORE_MENU_VISIBLE':
        return {
            ...state,
            moreMenuVisible: action.visible
        };
    case 'SET_PRESENT_MENU_VISIBLE':
        return {
            ...state,
            presentMenuVisible: action.visible
        };
    }
    
    return state;
}